module.exports = __webpack_public_path__ + "images/screenshot1.gif";